import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PhoneIcon from '@material-ui/icons/Phone';

const useStyles = makeStyles((theme) => ({
    ol: {
        fontSize: '12px',
        paddingLeft: '20px',
        '& ol': {
            paddingInlineStart: '20px',
        },
        '& .lower-alpha': {
            listStyleType: 'lower-alpha',
        },
        '& .lower-roman': {
            listStyleType: 'lower-roman',
        },
        '& li': {
            marginBottom: '6px',
        },
    },
    p: {
        fontSize: '14px',
    },
    t524__imgwrapper: {
        width: '150px',
        maxWidth: '100%',
        marginBottom: '20px',
        marginTop: '20px',
        align:'center',

    },
    person_img:{
        maxWidth: '150px',
        borderRadius:'50%',
        align:'center',
    },
    grid: {
        width: 'calc(100% + 8px)',
        margin: '0 -4px',
        '& > .MuiGrid-item': {
            padding: '5px',
        },
    },
    item: {
        paddingTop:'20px',
        padding: '8px',
        align:'center',
    },
    h3:{
        fontSize: '14px',
        padding: '0px',
    },
    h4:{
        fontSize: '12px',
        padding: '0px',
    },


}));

const Shipping = () => {
    const classes = useStyles();

    return (
        <section
            style={{
                minHeight: 'inherit',
                color: 'black',
                margin: '0 auto',
                padding: '20px',
                maxWidth: '1024px',
                backgroundColor: '#f05b83',

            }}
        >
            <center>
            <img src='/logo.png' alt='logo' width='90px' height='90px' className={classes.logoImg} />
            </center>

            <h1 style={{textAlign: 'center',fontSize:'24px'}}>Shipping</h1>
            <main>
                <p className={classes.p}>
	    		At Vending Buddy, we aim to provide a seamless and convenient experience for all our customers. 
	    		Since our vending machines require the physical presence of the customer to access and 
	    		purchase products, shipping is not applicable to any of our products or services.
                </p>

		<h4>Key Points:</h4>
		<ol>
			<b>No Shipping Required:</b>

			<ul>
				<li>All products are directly accessible at our vending machines.</li>
				<li>Customers can purchase and receive their items instantly from the vending machines at designated locations.</li>
			</ul>

			<b>Location Access:</b>

			<ul>
				<li>To purchase an item, simply visit any of our vending machines in person.</li>
				<li>Our vending machines are strategically placed to ensure accessibility and convenience.</li>
			</ul>

			<b>Support for In-Person Purchases:</b>

			<ul>
				<li>If you encounter any issues during your purchase, our customer service team is available to assist.</li>
			</ul>
		</ol>

		<p>
			For any further inquiries or assistance, please contact our support team via:
		</p>
                <p style={{fontSize: '20px'}}>
                        <MailOutlineIcon fontSize={'small'}></MailOutlineIcon> Email Contact: barun@neuu.in
                </p>
                <p style={{fontSize: '20px'}}>
                        <PhoneIcon fontSize={'small'}></PhoneIcon> Customer Care Number : 8951359305
                </p>

                <p className={classes.p}>
                    <center>
                    	<a href={'/'}>Home</a> | <a href={'/aboutus'}>About Us</a> | <a href={'/contactus'}>Contact Us</a>  | <a href={'/terms-and-conditions'}>Terms</a> | <a href={'/shipping'}>Shipping</a>
                    </center>
                </p>

            </main>

        </section>
    );
};
export default Shipping;
